import React from "react";
import EntityProfile from "../shared/entity/components/EntityProfile";
import entityOptions from "./config/entity";
import SupplierPartnerProfileFields from "./config/supplierPartnerProfileFields"
import { useSelector } from "react-redux";
import { getUserRoles } from "modules/auth/slice";

function Profile() {
    const getCurrentUserRoles = useSelector(getUserRoles());
    const isUserSupplierPartner = getCurrentUserRoles?.includes("supplier_partner_account_manager")

    return <EntityProfile options={isUserSupplierPartner ? { ...entityOptions, profileFields: SupplierPartnerProfileFields } : entityOptions} />;
}

export default Profile;
